import { z } from "zod";

export const setUserSkillsSchema = z
	.object({
		skill_ids: z.array(z.string().uuid()).max(50),
	})
	.strict();

export type SetUserSkillsPayload = z.infer<typeof setUserSkillsSchema>;
